import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Inventory Expiry Report";
const description = `The Inventory Expiry by Invoice Due Date Report is a specialized and high-level Financial Risk and Quality Assurance tool. It is designed to bridge the gap between physical inventory integrity and financial credit risk, particularly for businesses dealing with perishable goods, food, pharmaceuticals, or any product with a defined shelf life.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const InventoryExpiryReport: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryExpiryReport;
